<p-dropdown
  #dropdown
  class="osp-input-element"
  [options]="options()"
  [formControl]="control()"
  [optionLabel]="optionLabel()"
  [optionValue]="optionValue()"
  [filter]="filter()"
  [filterBy]="filterBy()"
  [showClear]="showClear()"
  [placeholder]="placeholder()"
  [styleClass]="cssClass()"
  [panelStyleClass]="panelStyleClass()"
  [loading]="loading()"
  [variant]="variant()"
  [appendTo]="appendTo()"
  [group]="group()"
  [readonly]="readonly()"
  [dataKey]="dataKey()"
  [virtualScroll]="$virtualScroll()"
  [virtualScrollItemSize]="$virtualScrollItemSize()"
  (onBlur)="onTouch()"
  (onChange)="onChange($event)"
>
  <ng-template [pTemplate]="dropdownCustomTemplateTypes.ITEM" let-item>
    <osp-dropdown-item
      [label]="item?.[optionLabel()]"
      [icon]="item?.icon"
      [selected]="item[optionValue()] === $controlValue()"
      [disabled]="item.disabled"
    />
  </ng-template>

  <ng-template [pTemplate]="dropdownCustomTemplateTypes.SELECTED_ITEM" let-item>
    <span [innerHTML]="item?.[optionLabel()]"></span>
  </ng-template>

  @if (dropdownCustomContent(); as customTemplates) {
    @for (customTemplate of customTemplates; track customTemplate.name) {
      <ng-template let-item [pTemplate]="customTemplate.name">
        <ng-container *ngTemplateOutlet="customTemplate.template; context: { $implicit: item }"></ng-container>
      </ng-template>
    }
  }
</p-dropdown>
